/**
 * Backbone survey graph rendering
 * used to render the results of poll(metric) field  in a "bar" chart
 */

export default (function() {
  //define couple of variables we are going to use for backbone models/collections/views
  var SurveyResultModel, SurveyResultsList, ComponentView, SurveyResultView;

  /**
   * model for one survey result, setting some defaults to be used.
   */
  SurveyResultModel = Backbone.Model.extend({
    defaults: {
      id:     '',
      label:  '',
      embed:  '',
      values: [], //options and their values with labels and embed code/image will be in here
    },
  });

  /**
   * collection of survey results models, will  hold the data for several question results
   */
  SurveyResultsList = Backbone.Collection.extend({
    url:   '/display/survey/resultsForQuestion.json',
    model: SurveyResultModel,
    parse: function(response) {
      if (response && response.status == 'ok') {
        return response.content;
      }
      return [];
    },
  });

  /**
   * survey result view with animating bars
   */
  SurveyResultView = Backbone.View.extend({
    //some defaults to be used
    defaultOptions: {
      metricDivId:           '',
      displayEmbed:          false,
      animationDuration:     1000,
      countDisplayType:      'percent', //'percent'/'value'
      minMetricWidthPercent: 0,
    },
    //initializes the options using the defaults and custom options passed into the component
    initialize: function(op) {
      this.options = $.extend(true, {}, this.defaultOptions, op.options);
    },
    //will render the graphs using what's on the model data
    render: function() {
      var surveyGraph = this.createGraph(this.model.toJSON(), this.options.displayEmbed);
      this.setElement(surveyGraph);
      return this;
    },
    //function creates the graph that needs to be rendered
    createGraph: function(metricData, displayEmbed) {
      var metricsExtremes = this.getMetricExtremes(metricData),
        me = this,
        roundedPercentages = this.getRoundPercentages(metricData.values, metricsExtremes),
        surveyGraph; //make some pre-calculations
      //check to see if the view is configured to show animation on the bars
      if (this.options.animationDuration && this.options.animationDuration > 0) {
        var itemGraphTemplate = NGX.App.api.getTemplate('metricItemGraph'),
          i,
          len;
        //draw the whole graph, but with the animation start point set to 0
        surveyGraph = $(me.createGraphHtml(metricData, metricsExtremes, 0, displayEmbed));
        var animator = $('<div>');
        animator.css('opacity', '0.0');
        animator.animate(
          {
            opacity: 1.0,
          },
          {
            step: function(now) {
              //animate each graph bar one by one
              var graphs = $('.xFormMetricItemGraphWrapper', $(surveyGraph));
              len = graphs.length;
              for (i = 0; i < len; i++) {
                var mTempModel = me.computeMetricData(
                  metricData.values[i],
                  metricsExtremes,
                  now * 100,
                  now == 1 ? roundedPercentages[i] : 0
                );
                $(graphs[i]).html(itemGraphTemplate(mTempModel));
              }
            },
            complete: function() {
              animator.remove();
            },
            duration: me.options.animationDuration,
          }
        );
      } else {
        //no animation is needed, just display the graphs
        surveyGraph = $(me.createGraphHtml(metricData, metricsExtremes, 100, displayEmbed, roundedPercentages));
      }
      return surveyGraph;
    },
    //creates HTML containing all metrics data at a given animation percent.
    createGraphHtml: function(metricData, metricsExtremes, animationPercent, displayEmbed, roundedPercentages) {
      var metricsHtml = '',
        i,
        m,
        metrics = metricData.values,
        len = metrics.length,
        componentTemplate = NGX.App.api.getTemplate('metricComponent'),
        metricTemplate = NGX.App.api.getTemplate('metricTemplate'),
        itemGraphTemplate = NGX.App.api.getTemplate('metricItemGraph');
      for (i = 0; i < len; i++) {
        m = metrics[i];
        m.displayEmbed = displayEmbed;
        if (displayEmbed && m.imageAssetRef) {
          m.imageAssetUrl = m.imageAssetRef.split(':')[3];
        }
        if (!(displayEmbed && m.embedCode)) {
          delete m.embedCode;
        }

        //creates the HTML for one metric data
        var mTempModel = this.computeMetricData(
          m,
          metricsExtremes,
          animationPercent,
          roundedPercentages != null ? roundedPercentages[i] : 0
        );
        mTempModel.itemGraph = itemGraphTemplate(mTempModel);
        metricsHtml += metricTemplate(mTempModel) + '\n';
      }

      var mCompModel = { label: metricData.label, metricsHtml: metricsHtml, metricDivId: this.options.metricDivId },
        mCompContent = componentTemplate(mCompModel);
      return mCompContent;
    },
    //computes the data(displayPercent/metricWidth/metricValue/extraClass) for a given metric at a given animation percent by knowing the extremes. The finalDisplayPercent is exact percent(the one that was rounded up)
    computeMetricData: function(metricData, metricsExtremes, animationPercent, finalDisplayPercent) {
      var metricWidthPercent, metricValue, displayPercent;
      metricWidthPercent = Math.floor((metricData.value * 100) / metricsExtremes.total) || 0; //metric bars will be relative to 100% instead of longest bar
      displayPercent = Math.round((metricData.value * 100) / metricsExtremes.total) || 0;

      if (finalDisplayPercent) {
        //on last item, make sure the total of percentages is 100
        displayPercent = metricsExtremes.total == 0 ? 0 : finalDisplayPercent;
      }
      metricValue =
        this.options.countDisplayType == 'percent' ?
          Math.round((displayPercent * animationPercent) / 100) + '%' :
          Math.round((metricData.value * animationPercent) / 100);

      return $.extend(true, { imageAssetRefAltText: '' }, metricData, {
        displayPercent: displayPercent,
        metricWidth:    (Math.max(this.options.minMetricWidthPercent, metricWidthPercent) * animationPercent) / 100 + '%',
        metricValue:    metricValue,
        extraClass:     metricData.value == metricsExtremes.max ? 'xFormMetricItemMaxScore' : '',
      });
    },
    //will look into the min/max values of the available metrics and will return an object containing the min/max/total values from the data
    getMetricExtremes: function(metricData) {
      var total = 0,
        max = Number.MAX_VALUE * -1,
        min = Number.MAX_VALUE,
        i,
        m,
        answers = metricData.values,
        len = answers.length;
      for (i = 0; i < len; i++) {
        m = answers[i];
        total += m.value;
        if (m.value > max) {
          max = m.value;
        }
        if (m.value < min) {
          min = m.value;
        }
      }
      return { total: total, min: min, max: max };
    },

    //calculates the percentages of each bar and makes sure it get's rounded percentages and those sum up to 100%
    getRoundPercentages: function(values, metricsExtremes) {
      var p = _.map(values, function(m) {
        return (m.value * 100) / metricsExtremes.total || 0;
      });
      return this.roundPercentages(p, 100);
    },

    /**
     * floating point JS calculations can be inexact
     * function makes sure the sum of the calculated percentages is "target" amount, by properly rounding up the values to get to the desired "target" value
     */
    roundPercentages: function(l, target) {
      var off =
        target -
        _.reduce(
          l,
          function(acc, x) {
            return acc + Math.round(x);
          },
          0
        ); //difference between the target value and sum of rounded values
      return _.chain(l)
        .map(function(x, i) {
          return { v: x, idx: i };
        }) //keep the original index
        .sortBy(function(x) {
          return Math.round(x.v) - x.v;
        }) //sort the items based on rounding that will happen
        .map(function(x, i) {
          return { v: Math.round(x.v) + (off > i) - (i >= l.length + off), idx: x.idx };
        }) //add a portion of the offset to the percentage and also keep the original order index
        .sortBy(function(x) {
          return x.idx;
        }) //sort to original order
        .pluck('v') //get the values
        .value();
    },
  });

  /**
   * loads and creates a list of survey results
   */
  ComponentView = Backbone.View.extend({
    //initializing the component
    initialize: function(options) {
      var me = this;
      this.options = options;
      this.model = options.model;

      _.bindAll(this, 'createCollection', 'addAll', 'addItem');

      this.$surveyResults = $('.xSurveyResults', '#' + this.el.id);

      me.createCollection('items');
    },
    // create a named collection within this view
    createCollection: function(name) {
      var qIds = this.$surveyResults.attr('selectedSurveyQuestionIds'),
        //creates a survey result collection list
        list = (this[name] = new SurveyResultsList({
          el: this.$surveyResults,
        })),
        params = {
          id:     qIds,
          apikey: NGX.context.apikey,
        };
      //listens for collection changes(reset/add)
      this.listenTo(list, 'reset', this.addAll);
      this.listenTo(list, 'add', this.addItem);
      //if metric data was added as an option when creating the component, render the values
      if (this.options.metricData) {
        list.set(this.options.metricData);
      } else {
        //metric data wasn't present, we need the list to fetch the data from the api
        list.fetch({
          data: params,
        });
      }
    },
    // build & render views for a whole collection
    addAll: function(collection) {
      _.each(
        collection.models,
        function(model) {
          this.addItem(model);
        },
        this
      );
    },
    // build and render an item view from its model
    addItem: function(model) {
      var obj = {
        model:   model,
        options: $.extend(true, this.options, {
          metricDivId:
            this.$surveyResults.attr('moduleId') +
            'xForm' +
            this.$surveyResults.attr('surveyContainerRef').split(':')[1] +
            'xQuestion' +
            model.attributes.id +
            'Metrics',
          displayEmbed: this.$surveyResults.attr('displayEmbed') === 'true',
        }),
      };
      var surveyView = this.$surveyResults.append(new SurveyResultView(obj).render().el);
      this.onPollRendered(surveyView[0]);
    },
    //called when the poll is rendered, will call a resize on the parent after the embedded images are loaded in
    onPollRendered: function(surveyView) {
      $(surveyView).imagesLoaded(function() {
        NGX.App.api.resizeParent();
      });
    },
  });

  NGX.comps.push({ type: 'metric', view: ComponentView });
})();
